<template>
  <div class="grid p-fluid animate__animated animate__fadeIn">
    <div class="col-12">
      <div class="card card-w-title">
        <div v-if="feedbacks">
          <div class="flex flex-row w-full border-solid border-gray-200 p-2">
            <div class="w-3rem h-10rem surface-300 border-round-md mr-2 mt-3 mb-3">
              <div class="flex justify-content-center">
                <div class="mt-2">
                  <div>
                    <i class="pi pi-thumbs-up" style="font-size: 1.5rem"></i>
                  </div>
                  <span class="mr-2">{{ feedbacks.likeCount }}</span>
                </div>
              </div>
              <hr />
              <div class="flex justify-content-center">
                <div>
                  <div>
                    <i class="pi pi-thumbs-down" style="font-size: 1.5rem"></i>
                  </div>
                  <span class="mr-2">{{ feedbacks.disLikeCount }}</span>
                </div>
              </div>
            </div>
            <div class="mt-4 mr-4">
              <div class="flex flex-row">
                <div v-if="feedbacks.fullName == null">کاربر</div>
                <div v-else>{{ feedbacks.fullName }}</div>
                <div class="text-400 mr-4">{{ new Date(feedbacks.createdAt).toLocaleDateString("fa-IR") }}</div>
              </div>
              <div class="mt-4">{{ feedbacks.message }}</div>
            </div>
          </div>
          <div v-for="(reeply, index) in feedbacks.replys" class="border-solid border-gray-200 p-2 mt-2" :class="[index % 2 == 0 ? 'md:mr-6  border-cyan-200 ' : '']" :key="index">
            <div class="flex flex-row w-full">
              <div class="w-3rem h-10rem surface-300 border-round-md mr-2 mt-3 mb-3">
                <div class="flex justify-content-center">
                  <div class="mt-2">
                    <div>
                      <i class="pi pi-thumbs-up" style="font-size: 1.5rem"></i>
                    </div>
                    <span class="mr-2">{{ reeply.likeCount }}</span>
                  </div>
                </div>
                <hr />
                <div class="flex justify-content-center">
                  <div>
                    <div>
                      <i class="pi pi-thumbs-down" style="font-size: 1.5rem"></i>
                    </div>
                    <span class="mr-2">{{ reeply.disLikeCount }}</span>
                  </div>
                </div>
              </div>
              <div class="mt-2 mr-4 w-11">
                <div class="flex flex-row">
                  <div v-if="reeply.fullName == null" class="mt-2">ادمین</div>
                  <div v-else class="mt-2">{{ reeply.fullName }}</div>
                  <div class="text-400 mr-4 mt-2">{{ new Date(reeply.createdAt).toLocaleDateString("fa-IR") }}</div>
                  <div class="w-full flex justify-content-end flex-wrap">
                    <div class="md:w-1 xl:w-1">
                      <Button label="حذف" class="h-3rem p-button-text text-xs p-button-warning" @click="(idDelete = reeply.id), (display = true)" />
                    </div>
                    <div v-if="!reeply.isAccepted" class="md:w-1 xl:w-1">
                      <Button label="تایید" class="h-3rem p-button-text p-button-success text-xs mr-1 mb-2" @click="checkComments(reeply.id, true)" />
                    </div>
                    <div v-if="reeply.isAccepted" class="md:w-1 xl:w-1">
                      <Button label="رد کردن" class="h-3rem p-button-text p-button-danger text-xs mr-1 mb-2" @click="checkComments(reeply.id, false)" />
                    </div>
                  </div>
                </div>
                <div class="mb-2">{{ reeply.message }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="textra" class="mt-4">
          <Textarea v-model="value" placeholder="پاسخ" :autoResize="true" rows="5" cols="30" />
          <div class="w-full flex justify-content-end">
            <Button label="ثبت" @click="sendReplays" class="w-6rem h-3rem p-button-Primary" />
          </div>
        </div>
      </div>
    </div>
    <Dialog v-model:visible="display" :style="{ width: '450px' }" header="حذف" :modal="true">
      <div class="flex flex-column align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle" style="font-size: 4rem" />
        <span class="mt-3">آیا مطمئن هستید؟</span>
      </div>
      <template #footer>
        <div class="text-center">
          <Button label="خیر" icon="pi pi-times" class="p-button-text" @click="display = false" />
          <Button label="بلی" icon="pi pi-check" class="p-button-text" @click="confirmDeleteFeedback(idDelete), (display = false)" />
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      feedbacks: null,
      value: "",
      textra: true,
      placeId: null,
      feedbackID: null,
      idDelete: null,
      display: false,
    };
  },
  methods: {
    async getData() {
      const { status, data } = await this.axios({ method: "get", url: `/Place/${this.placeId}/feedback/${this.feedbackID}/Details` });
      if (status == 200) {
        this.feedbacks = { ...data };
        if (data.replys.length % 2 !== 0) {
          this.textra = false;
        } else {
          this.textra = true;
        }
      }
    },
    async checkComments(id, flage) {
      const { status, data } = await this.axios({
        method: "put",
        url: `/place/${this.placeId}/feedback/${id}/Accept`,
        data: {
          isAccept: flage,
        },
      });
      if (status == 200) {
        this.feedbacks.replys.forEach((item) => {
          if (item.id == id) {
            item.isAccepted = !item.isAccepted;
          }
        });
        this.showToast(status, data.errors);
      }
    },
    async confirmDeleteFeedback(id) {
      const { status, data } = await this.axios({ method: "delete", url: `/place/${this.placeId}/feedback/${id}/Delete` });
      if (status == 200) {
        const result = this.feedbacks.replys.filter((item) => {
          return item.id !== id;
        });
        this.feedbacks.replys = result;
        console.log(result);
        this.showToast(status, data.errors);
        if (this.feedbacks.replys.length == 0) {
          this.textra = true;
          this.value = "";
        } else if (this.feedbacks.replys.length % 2 == 0) {
          this.textra = true;
          this.value = "";
        } else {
          this.textra = false;
        }
      }
    },
    async sendReplays() {
      const { status, data } = await this.axios({ method: "post", url: `/Place/${this.placeId}/feedback/${this.feedbackID}/Reply`, data: { message: this.value } });
      if (status === 200) {
        this.getData();
      }
    },
  },
  mounted() {
    this.placeId = this.$route.params.palce_id;
    this.feedbackID = this.$route.params.feed_id;
    console.log(this.placeId, this.feedbackID);
    this.getData();
  },
};
</script>

<style></style>
